import styled from 'styled-components'
import { useTranslation } from '@i18n'
import Button, { ButtonVariant } from '@components/DesignSystem/Button'
import AmpLightBoxAdCloseButton from './AmpLightBoxAdCloseButton'
import AmpLightBoxAdContainer from './AmpLightBoxAdContainer'

const ConfirmContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
`

const ConfirmBox = styled.div`
  background: white;
  padding: 40px;
  border-radius: 8px;
  text-align: center;
  max-width: 320px;
`

export default function AmpArticlePopUpLightboxAd({ isR18Article, isLoveSite }) {
  const { t } = useTranslation('post')
  const getAdSlot = () => {
    if (isR18Article) return '/90969475/amp_18adult_All_Popup_MB'
    if (isLoveSite) return '/90969475/amp_love_All_Popup_MB'
    return '/90969475/amp_All_Popup_MB'
  }

  return (
    <>
      {/* 確認彈窗 animation */}
      <amp-animation id="showConfirmAnim" layout="nodisplay">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              duration: '1ms',
              fill: 'both',
              iterations: '1',
              direction: 'alternate',
              animations: [
                {
                  selector: '#confirmPopup',
                  keyframes: [{ opacity: '1', visibility: 'visible' }],
                },
              ],
            }),
          }}
        />
      </amp-animation>
      <amp-animation id="hideConfirmAnim" layout="nodisplay">
        <script
          type="application/json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              duration: '200ms',
              fill: 'both',
              iterations: '1',
              direction: 'alternate',
              animations: [
                {
                  selector: '#confirmPopup',
                  keyframes: [{ opacity: '0', visibility: 'hidden' }],
                },
              ],
            }),
          }}
        />
      </amp-animation>
      {/* 確認彈窗 trigger */}
      <div style={{ position: 'absolute', top: '20%' }}>
        {/* Do not remove the ="" on once="" to prevent amp error: The attribute 'once' in */}
        {/* tag 'amp-position-observer' is set to the invalid value 'true'. */}
        <amp-position-observer on="enter:showConfirmAnim.start" layout="nodisplay" once="" />
      </div>
      {/* 確認彈窗 */}
      <ConfirmContainer id="confirmPopup">
        <ConfirmBox>
          <p style={{ color: '#666' }}>{t('ampPopupAd.clickToView')}</p>
          <Button
            variant={ButtonVariant.primary}
            on="tap:hideConfirmAnim.start,popupAdLightbox.open"
            style={{ marginTop: 20 }}
          >
            {t('ampPopupAd.confirm')}
          </Button>
        </ConfirmBox>
      </ConfirmContainer>
      {/* 蓋版廣告 lightbox */}
      <amp-lightbox
        id="popupAdLightbox"
        layout="nodisplay"
        style={{ position: 'relative', zIndex: 9999, background: 'rgba(0,0,0,0.8)' }}
      >
        <AmpLightBoxAdCloseButton on="tap:popupAdLightbox.close" />
        <AmpLightBoxAdContainer>
          <amp-ad width="336" height="280" type="doubleclick" data-slot={getAdSlot()} />
        </AmpLightBoxAdContainer>
      </amp-lightbox>
    </>
  )
}
